import { Injectable } from "@angular/core";
import { InappService } from "../inapp/inapp.service";
import { Platform } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})

export class TransformOffersService {
  private getProductOfferSubcription: any;
  private bonusPurchases: any;
  private coinPurchases: any;
  private transformedOffers: any;

  constructor(private inappService: InappService, private platform: Platform) {
    if (this.getProductOfferSubcription) this.unSubcriber();
    this.getProductOfferSubcription = this.inappService
      .getUpdatedOffers()
      .subscribe((offers) => {
        if (offers) {
          this.transformedOffers = this.transformOffersToIdMap(offers);
        }
      });
  }
  unSubcriber() {
    if (this.getProductOfferSubcription) {
      try {
        this.getProductOfferSubcription.unsubcribe();
      } catch (e) {
        console.log("Error while Unsubcribing", e);
      }
    }
  }
  transformOffersToIdMap(offers) {
    if (!offers || !Array.isArray(offers)) return {};
    const offersById = {};
    if (this.platform.is("ios")) {
      offers.forEach((offer) => {
        offersById[offer.raw.id] = {
          price: offer.raw.price.replace(/[^\d.]/g, ""),
          priceMicros: offer.raw.priceMicros,
          id: offer.raw.id,
          countryCode: offer.raw.countryCode,
          currency: offer.raw.currency,
          description: offer.raw.description,
        };
      });
    }
    if (this.platform.is("android")) {
      offers.forEach((offer) => {
        offersById[offer.id] = {
          price: offer.offers[0].pricingPhases[0].price.replace(/[^\d.]/g, ""),
          priceMicros: offer.offers[0].pricingPhases[0].priceMicros,
          id: offer.id,
          currency: offer.offers[0].pricingPhases[0].currency,
          description: offer.description,
        };
      });
    }
    return offersById;
  }
  public transformOfferPrices(items) {
    return items.map((item) => {
      if (this.transformedOffers[item.priceCode]) {
        return {
          ...item,
          price: this.transformedOffers[item.priceCode].price,
          priceAmount:this.transformedOffers[item.priceCode].price,
        };
      } else return item;
    });
  }
}
